import { Fragment, useMemo } from "react";
import Container from "modules/Core/sub-modules/ui-kit/components/Container"
import BoothScheduleTab from "../../BoothScheduleTab";
import BoothScreen from "modules/shelter/components/BoothScreen";
import EntriesFeed from "modules/entries/components/EntriesFeed";
import AddEntryButton from "modules/entries/components/AddEntryButton";
import Cycle from "modules/cycles/components/Cycle";
import RoadmapsFeed from "modules/roadmaps/components/RoadmapsFeed";
import AddRoadmapButton from "modules/roadmaps/components/AddRoadmapButton";
import IntrospectionCard from "../../IntrospectionCard";
import Card from "modules/Core/sub-modules/ui-kit/components/Card";
import DedicatedTimeFeed from "modules/timetracker/components/DedicatedTimeFeed";
import SubBoothsCard from "../../SubBoothsCard";
import { BOOTH_KINDS } from "modules/booths/consts";
import BoothsScreenHeader from "modules/shelter/components/BoothScreen/BoothScreenHeader"
import { BOOTHS } from "../../InfoComponent/lib/keys"
import FeatureWrapper from "modules/Core/components/FeatureWrapper";
import styles from "./styles.module.scss";


const tabs = [
    {
        title: "Time schedule",
        Component: ({ boothId }) => <BoothScheduleTab initialView='day' p1 maxWidth maxHeight borderless boothId={boothId} />
    },
    {
        title: 'Dedicated times',
        Component: ({ boothId }) => (
            <Container flex col alignCenter maxWidth>
                <DedicatedTimeFeed col className={styles.dedicatedTimeFeedContainer} boothId={boothId} />
            </Container>
        )
    }

]

const BoothTimeIntrospectionCard = ({ boothId, ...props }) => {
    const tabProps = useMemo(() => ({ boothId }), [boothId])
    const fallback = useMemo(() => (
        <Card maxHeight borderless>
            <DedicatedTimeFeed col className={styles.dedicatedTimeFeedContainer} boothId={boothId} />
        </Card>
    ), [boothId])
    return (
        <IntrospectionCard title="Time schedule" className={styles.card} {...props}>
            <FeatureWrapper featureKey="time-mapping" fallback={fallback}>
                <Card maxHeight borderless tabs={tabs} tabProps={tabProps} />
            </FeatureWrapper>
        </IntrospectionCard>
    )
}

export default ({ focusedBoothId, boothId = focusedBoothId }) => (
    <BoothScreen
        tripanel
        boothId={boothId}
        RightPanelComponent={Fragment}
    >

        <Container className={styles.container}>
            <BoothsScreenHeader
                header="Booth home"
                infoKey={BOOTHS.homescreen}
            />
            <Container className={styles.cardsContainer}>
                <BoothTimeIntrospectionCard boothId={boothId} />
                <IntrospectionCard className={styles.card} title="Cycle" maxWidth maxHeight>
                    <Cycle />
                </IntrospectionCard>
                <IntrospectionCard className={styles.card} title="Roadmaps" maxWidth maxHeight>
                    <Container maxWidth maxHeight flex col alignCenter>
                        <RoadmapsFeed boothId={boothId} />
                        <AddRoadmapButton boothId={boothId} />
                    </Container>
                </IntrospectionCard>
                <IntrospectionCard className={styles.card} title="Entries" maxWidth maxHeight>
                    <AddEntryButton className={styles.entriesButton} boothId={boothId} />
                    <EntriesFeed boothId={boothId} />
                </IntrospectionCard>
            </Container>
            <FeatureWrapper featureKey="malchut">
                <Container>
                    <SubBoothsCard
                        parentId={boothId}
                        kind={BOOTH_KINDS.MALCHUT}
                    />
                </Container>
            </FeatureWrapper>

        </Container>
    </BoothScreen >
)
